import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './components/App';
import { CollectionProvider } from './context/collection';
import './app.scss';

ReactDOM.render(
  <CollectionProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </CollectionProvider>,
  document.getElementById('root')
);
